// extracted by mini-css-extract-plugin
export default {"grid":"Form-module_grid_e32ca6","link":"Form-module_link_d7f8c6"};